import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import { FilterOption } from './types'

export const dateRangeFilters: FilterOption = {
  divider: false,
  groupOrAble: false,
  icon: 'gem-calendar',
  id: uuidv4(),
  inclusivity: false,
  title: 'Live Date Range',
  childOptions: [
    {
      divider: false,
      groupOrAble: false,
      inclusivity: false,
      icon: 'gem-calendar',
      id: 'duration_starts_at',
      title: 'On or after',
      type: 'date',
      payload: {
        type_key: 'duration',
        object: {
          value: moment(),
          key: 'duration_starts_at',
        },
      },
    },
    {
      divider: false,
      groupOrAble: false,
      icon: 'gem-calendar',
      id: 'duration_ends_at',
      inclusivity: false,
      title: 'On or before',
      type: 'date',
      payload: {
        type_key: 'duration',
        object: {
          value: moment(),
          key: 'duration_ends_at',
        },
      },
    },
  ],
}
